/**
 * 역할 이름 — 사람이 읽는 말.
 *
 * **역할 id 가 화면 이름과 같다**(2026-09-18 사용자 지시로 id 를 이름에 맞췄다):
 *
 *   admin   관리자   고객사의 관리 등급 — 편성·화면·자기 팀 계정까지
 *   system  시스템   공급사(개발) 등급 — 긴급 오버라이드·릴리스·서비스 토큰·정비 모드·플러그인
 *
 * 그 전에는 `operator` 가 고객사 등급, `admin` 이 공급사 등급이었다(잠시 있던 `developer` 도 공급사).
 * 서버가 저장된 값을 부팅 때 한 번 옮긴다. **`admin` 의 뜻이 바뀌었으니** 이 날 전에 쓴 코드 주석·문서의
 * `admin` 은 대개 지금의 `system` 이다 — 헷갈리면 날짜를 본다.
 *
 * 이름표가 사이드바·사용자 화면·내 계정에 따로 있었더니 한 곳에는 개발자가 빠져 있었다.
 * 여기 한 벌만 둔다.
 */
import type { Role } from './api/client.js';

export const ROLE_LABEL: Readonly<Record<Role, string>> = {
  viewer: '조회',
  auditor: '감사',
  'content-manager': '콘텐츠 관리',
  admin: '관리자',
  system: '시스템',
};

/** 모르는 값(옛 서버·오타)은 id 를 그대로 보인다 — 빈칸보다 낫다. */
export function roleLabel(role: string): string {
  return (ROLE_LABEL as Record<string, string>)[role] ?? role;
}
